import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk } from "redux-thunk"; // Import thunk correctly

// Combine reducers
const rootReducer = combineReducers({

});

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  blacklist: [], // Add slices you don't want to persist
  debug: true,
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Middleware setup function
const setupMiddleware = () => {
  const middleware = [thunk];
  return middleware;
};

// Create Redux store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: () => setupMiddleware(),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools in development
});

// Create persistor object
export const persistor = persistStore(store);
